(function () {
    'use strict';

    /*
     UserLogoutController
    -------------------------------------------------------------------------- */

    angular
        .module('UserApp.logout', [])
        .controller('UserLogoutController', [
            '__DataStore',
            '__Auth',
            'appServices',
            UserLogoutController
        ]);

    /**
      * UserLogoutController for login logout
      *
      * @inject __DataStore
      * @inject __Auth
      * @inject appServices
      * 
      * @return void
      *-------------------------------------------------------- */

    function UserLogoutController(__DataStore, __Auth, appServices) {

        var scope = this;

        __DataStore.post('user.logout').success(function (responseData) {

            appServices.processResponse(responseData, function (reactionCode) {

                // set user auth information
                __Auth.checkIn(responseData.data.auth_info);

            });

        });

    };

})();